import React from "react";
import marketing from "../../assets/images/services/marketing.png";
import socialMedia from "../../assets/images/services/socialMedial_new.png";
import branding from "../../assets/images/services/branding_new.jpeg";
import production from "../../assets/images/services/production_new.jpeg";
import web from "../../assets/images/services/web_new.jpeg";
import analytics from "../../assets/images/services/analytics_new.jpeg";
import { BsArrowUpRight } from "react-icons/bs";
import { GoArrowRight } from "react-icons/go";
import { useStateContext } from "../../context/ContextProvider";

import serviceSocial from "../../assets/images/graphics/social.svg";
import serviceWeb from "../../assets/images/graphics/web.svg";
import serviceCreative from "../../assets/images/graphics/creative.svg";
import serviceBranding from "../../assets/images/graphics/branding.svg";
import serviceDigital from "../../assets/images/graphics/digitalmarketing.svg";
import useFadeInOnScroll from "../../components/Effects/FadeInOnScroll";

const Services = () => {

  const {
    isMobile
  } = useStateContext();

  useFadeInOnScroll();

  const services = [
    {
      "title": "Digital Marketing <br />Solutions",
      "subtitle": "Drive Measurable Growth & Deepen Engagement",
      "description": "Harness cutting-edge strategies to increase your revenue, enhance your online presence, and connect meaningfully with your target audience.",
      "subservices": [
        "Strategic Planning",
        "SEO & SEM",
      ],
      "image": serviceDigital,
      "itype": "square"
    },
    {
      "title": "Social media <br /> Marketing and management",
      "subtitle": "Amplify Your Brand’s Online Impact",
      "description": "Boost your visibility and foster customer loyalty with customized content and strategic advertising tailored to each social platform.",
      "subservices": [
        "Platform Management",
        "Creative Content",
        "Paid Campaigns"
      ],
      "image": serviceSocial,
      "itype": "rectangle"
    },
    {
      "title": "Branding <br /> Services",
      "subtitle": "Build a Distinctive & Memorable Identity",
      "description": "Create a powerful brand that resonates emotionally with your audience, setting you apart in the marketplace and driving long-term loyalty.",
      "subservices": [
        "Visual Identity",
        "Brand Storytelling",
        "Strategic Branding"
      ],
      "image": serviceBranding,
      "itype": "square"
    },
    {
      "title": "Creative <br />Production",
      "subtitle": "Engage & Inspire with stunning content",
      "description": "Captivate your audience through high-quality videos, graphics, and interactive designs that communicate your brand’s story and values effectively.",
      "subservices": [
        " Video Production",
        "Graphic Design",
        "Interactive Content"
      ],
      "image": serviceCreative,
      "itype": "square"
    },
    {
      "title": "Web Development <br />& E-commerce Solutions",
      "subtitle": "Maximize your Online Potential",
      "description": "Develop high-performance, user-friendly websites and e-commerce platforms that enhance user experience, drive sales, and support your business growth.",
      "subservices": [
        "Website Design",
        "UI/UX",
        "E-Commerce"
      ],
      "image": serviceWeb,
      "itype": "rectangle"
    },
    // {
    //   "title": "",
    //   "subtitle": "",
    //   "description": "",
    //   "subservices": [
    //     "",
    //     "",
    //     ""
    //   ],
    //   "image": "",
    // }
  ];


  const servicesList = [
    {
      heading: "Digital Marketing Solutions",
      text: "Drive Measurable Growth & Deepen Engagement",
      img: marketing,
      categories: ["Strategic Planning", "SEO & SEM"],
    },
    {
      heading: "Social Media Marketing",
      text: "Amplify Your Brand’s Online Impact",
      img: socialMedia,
      categories: ["Paid Campaigns", "Creative Content", "Platform Management"],
      flip: true,
    },
    {
      heading: "Branding Services",
      text: "Build a Distinctive & Memorable Identity",
      img: branding,
      categories: [
        "Visual Identity",
        "Brand Storytelling",
        "Strategic Branding",
      ],
    },
    {
      heading: "Creative Production",
      text: "Engage & Inspire with Stunning Content",
      img: production,
      categories: ["Video Production", "Graphic Design", "Interactive Content"],
      flip: true,
    },
    {
      heading: " Web Development ",
      text: "Maximize Your Online Potential",
      img: web,
      categories: ["Website Design", "UI/UX", "E-Commerce"],
    },
    {
      heading: " Data Analytics ",
      text: "Make Informed Decisions with Actionable Insights",
      img: analytics,
      categories: [
        "Performance Analysis",
        "Actionable Reports",
        "Behavior Insight",
      ],
      flip: true,
    },
  ];
  return (
    <>
      <div className="w-full relative py-5">
        <div className="h-[50px]"></div>
        <div className="relative padding-container w-full my-5 py-5 text-start z-1 flex flex-col gap-4">
          <div className="text:4xl md:text-5xl lg:text-6xl uppercase font-bold">
            Services
          </div>
          <div className="flex flex-col lg:flex-row lg:items-end gap-5">
            <h1 className="text:6xl md:text-7xl lg:text-8xl uppercase font-bold">
              EVERY DO&nbsp;
              <br className="hidden lg:flex" />
              SHAPES
              <br />
              THE DEAL
            </h1>
            <div className="lg:max-w-[50vw] w-[300px] text-xs text-[var(--l-gray)] mb-5">
              With DODEAL, your goals are our mission. From groundbreaking
              marketing campaigns to seamless tech integrations, we provide the
              tools, insights, and support needed to navigate challenges and
              deliver impactful results that resonate with your audience.
            </div>
          </div>
        </div>

        {services.map((link, index) => (
          <div className={`relative w-[100vw] h-[100vh] lg:border overflow-hidden grid grid-cols-1 md:grid-cols-2  ${index % 2 === 0
            ? "bg-white text-[var(--secondary)]"
            : "bg-primary text-white"
            }`}>
            <div className="hidden md:flex absolute right-0 top-[-20px]">
              <div className="fade-element font-bold leading-none text-[200px] text-grad-top">
                0{index + 1}
              </div>
            </div>
            <div className="absolute top-[calc(100%-300px)] left-[calc(100%-450px)] rounded-full h-[600px] w-[600px] -z-1"
              style={{
                backgroundImage: "linear-gradient(to right, var(--primary), var(--secondary)",
                zIndex: 0
              }}></div>

            <div className="padding-container !py-5 w-full h-full" style={{ zIndex: 2 }}>
              <div className="hidden md:flex h-[50px]"></div>
              <div className="padding-container w-full h-full flex flex-col items-start gap-2">
                <div className="fade-element md:hidden text-4xl">
                  0{index + 1}
                </div>
                <div className="fade-element text-3xl lg:text-4xl lg:w-[calc(100%+40%)] text-[var(--primary)] uppercase font-bold"
                  dangerouslySetInnerHTML={{ __html: link?.title }}
                // dangerouslySetInnerHTML={{ __html: link?.title }}
                />
                <div className="fade-element text-lg mb-5 lg:w-[calc(100%+40%)] uppercase font-bold">
                  {link?.subtitle}
                </div>
                <div className={`fade-element w-full mb-5 font-light`}>
                  {link?.description}
                </div>
                <div className="flex flex-wrap md:flex-col gap-3">
                  {link?.subservices?.map((sub, subIndex) => (
                    <div key={subIndex} className="fade-element w-fit rounded-full border px-4 py-1">
                      {sub}
                    </div>
                  ))}
                </div>
              </div>
            </div>

            {link?.image && (
              link?.itype === "rectangle" ? (
                <div className="absolute bottom-0 right-1/2 translate-x-1/2 md:translate-x-0 md:right-0 md:pr-5 w-[200vw] md:w-[70vw] md:h-[60vh] flex items-center justify-center md:items-end md:justify-end">
                  <img
                    src={link?.image}
                    alt="DODEAL"
                    className={`fade-element w-full h-auto md:w-auto md:h-full flex items-end`}
                    style={{ zIndex: 1 }} />
                </div>
              ) : (
                <div className="pr-5 w-full h-full flex items-center md:items-end justify-center">
                  <img
                    src={link?.image}
                    alt="DODEAL"
                    className={`fade-element !max-w-[100%] md:!max-w-[90%] max-h-[80%] w-full h-full`}
                    style={{ zIndex: 1 }} />
                </div>
              )
            )}
          </div>
        ))}

        {/* <div className="padding-container relative w-full min-h-[100vh] my-5 py-5">
          <div className="w-full my-5 py-5">
            {servicesList?.map((service) => (
              <ServicesSection service={service} />
            ))}
          </div>
        </div> */}
      </div>
    </>
  );
};

export default Services;

const ServicesSection = ({ service }) => {
  const { isMobile } = useStateContext();
  return (
    <div className="flex  mb-5 w-full">
      {(isMobile ? false : service?.flip) ? (
        <div className="flex flex-col md:flex-row items-center justify-center md:justify-start mb-5 space-x-5 w-full">
          <div className={"md:flex-1  flex flex-col items-center w-[50%]"}>
            <div>
              <h1 className="text-white font-effra text-3xl font-bold mb-4 text-center md:text-left">
                {service?.heading}
              </h1>
              <p className="text-white font-effra text-sm font-medium text-center md:text-left">
                {service?.text}
              </p>
              <div className="flex flex-col items-center md:flex-row md:items-start  mt-6 flex-wrap gap-4">
                {service?.categories?.map((cat) => (
                  <p className="border border-white font-effra text-white text-nowrap text-sm text-center bg-transparent rounded-full px-3 py-3 mb-2 md:mb-0">
                    {cat}
                  </p>
                ))}
              </div>
            </div>
          </div>
          <div className="relative flex justify-center w-full  md:w-[50%]">
            <img
              src={service?.img}
              alt="services image"
              className=" w-full h-full"
            />
            <div className="absolute bottom-0 translate-y-1/2 bg-[#00AE6B] border-[4px] border-white rounded-full p-4">
              <GoArrowRight />
            </div>
          </div>
        </div>
      ) : (
        <div className="flex flex-col md:flex-row items-center justify-center md:justify-start mb-5 space-x-5 w-full gap-11">
          <div className="flex justify-center w-full relative md:w-[50%]">
            <img
              src={service?.img}
              alt="services image"
              className=" w-full h-full"
            />
            <div className="absolute bottom-0 translate-y-1/2 bg-[#00AE6B] border-[4px] border-white rounded-full p-4">
              <GoArrowRight />
            </div>
          </div>
          <div className={"md:flex-1 w-[50%]  flex flex-col items-center "}>
            <div>
              <div className="">
                <h1 className="text-white text-3xl font-bold mb-4 text-center md:text-left">
                  {service?.heading}
                  <br />
                </h1>
                <p className="text-white text-sm font-medium text-center md:text-left">
                  {service?.text}
                </p>
              </div>
              <div className="flex flex-col items-center md:flex-row md:items-start gap-6 mt-6 flex-wrap">
                {service?.categories?.map((cat) => (
                  <p className="border border-white text-white text-nowrap text-sm text-center bg-transparent rounded-full px-3 py-3 mb-2 md:mb-0">
                    {cat}
                  </p>
                ))}
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
